<template>
    <div class="wrap-tabs">
        <div class="wrap-tabs__content tab-conditions">
            <ul class="tab-conditions__list">
                <li v-for="(item, index) in eventWorldcupInfo.conditionList" :key="index" v-html="item.text" />
            </ul>
            <div class="tab-conditions__note">
                <div class="note">
                    <img src="/assets/img/event/seagame/tabs/note.svg" alt="note">
                    LƯU Ý
                </div>
                <div class="text">
                    <p>{{eventWorldcupInfo.note}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import { eventWorldcupInfo } from '@/resources/worldcup/worldcup';

export default {
    data() {
        return {
            eventWorldcupInfo
        };
    }
};
</script>
